import { useRef, useEffect, useState } from "react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { FileText, CheckCircle, XCircle, CreditCard, Shield, AlertTriangle, Mail, Scale, Users, Zap, ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import {AutoTranslate} from "@/lib/autoTranslate.tsx"
import { useTranslation} from "react-i18next";
import { SEO } from "@/components/SEO";





export default function Terms() {

  const [data, setData] = useState(0);

  const { i18n } = useTranslation();

  console.log(i18n.language);
  const lastUpdated = AutoTranslate("September 19th, 2025");
  const navigate = useNavigate();
  // if(!ready){
  //   console.log("what");
  //   return <p> one moment... </p>;
  // }
  const handleBackToLanding = () => {
    navigate('/');
  };


  const sections = [
    {
      icon: <CheckCircle className="h-5 w-5 text-primary" />,
      title: AutoTranslate("1. Acceptance of Terms"),
      content: AutoTranslate(`By accessing and using Resume Builder AI, you accept and agree to be bound by these Terms of Service:

• Agreement: These terms constitute a legally binding agreement between you and Resume Builder AI
• Eligibility: You must be at least 16 years old to use our service
• Capacity: You represent that you have the legal capacity to enter into this agreement
• Updates: We may modify these terms at any time, with changes taking effect immediately upon posting
• Continued Use: Your continued use of the service after changes constitutes acceptance of new terms
• Entire Agreement: These terms, together with our Privacy Policy, constitute the entire agreement between us`)
    },
    {
      icon: <Users className="h-5 w-5 text-primary" />,
      title: AutoTranslate("2. Service Description"),
      content: AutoTranslate(`Resume Builder AI provides an AI-powered platform for creating professional resumes:

• Core Service: Interactive AI assistant that guides users through resume creation
• Resume Generation: Automated formatting and professional presentation of user-provided information
• File Formats: Download resumes in PDF and DOCX formats
• Voice Input: Optional voice recording feature for hands-free information input
• Storage: Cloud-based storage for Pro users to save and access multiple resumes
• Subscription Tiers: Free and Pro plans with different feature sets and limitations
• Third-Party Integration: Integration with OpenAI for AI processing and Paystack for payments`)
    },
    {
      icon: <Users className="h-5 w-5 text-primary" />,
      title: AutoTranslate("3. User Accounts and Registration"),
      content: AutoTranslate(`Account creation and management requirements:

• Account Creation: You must create an account to access certain features of our service
• Accurate Information: You agree to provide accurate, current, and complete information during registration
• Account Security: You are responsible for safeguarding your account credentials
• Unauthorized Access: You must notify us immediately of any unauthorized access to your account
• Account Termination: We reserve the right to terminate accounts that violate these terms
• Data Responsibility: You are responsible for all activity that occurs under your account
• Single Account: Each user may maintain only one account`)
    },
    {
      icon: <CreditCard className="h-5 w-5 text-primary" />,
      title: AutoTranslate(`4. Subscription Plans and Billing`),
      content: AutoTranslate(`Our service offers both free and paid subscription options:

• Free Plan: Limited features including single resume creation and basic download functionality
• Pro Plan: Enhanced features including unlimited resume storage, advanced templates, and priority support
• Billing Cycles: Monthly ($10/month) and annual ($90/year) billing options for Pro subscriptions
• Auto-Renewal: Subscriptions automatically renew unless cancelled before the next billing cycle
• Payment Processing: All payments are processed securely through Paystack. We do not store your payment card, bank, or transfer details
• Payment Confirmation: Pro access is activated after Paystack confirms a successful payment and the account subscription status is updated
• Cancellation: You may cancel or downgrade from your account billing settings. When a paid plan is cancelled, Pro access continues until the active paid period ends
• Price Changes: We may change subscription prices with 30 days advance notice
• Taxes: You are responsible for any applicable taxes on your subscription`)
    },
    {
      icon: <Scale className="h-5 w-5 text-primary" />,
      title: AutoTranslate("5. Refund Policy"),
      content: AutoTranslate(`We offer a fair and transparent refund policy for Pro subscription payments processed through Paystack:

• 14-Day Window: Request refunds within 14 days of your most recent Pro subscription payment
• Usage Condition: Refunds are available only if none of the Pro benefits from that billing period were used, including Pro downloads, saved resume storage, advanced templates, ATS/job tailoring, or other paid features
• Eligible Payments: Only the most recent subscription payment qualifies for refund review. Older payments and payments outside the 14-day window are not eligible
• Refund Process: Submit requests to info@wefindservices.org with your account email, payment date, Paystack reference if available, and a brief reason for the request
• Review Process: We may check account activity, payment confirmation, resume downloads, saved resumes, and Pro feature usage before approving a refund
• Refund Timing: Approved refunds are issued within 14 days to the original payment method used through Paystack. Your bank or card provider may take additional time to reflect the money
• Service Access: Refunded accounts revert to Free plan limitations immediately after the refund is issued
• No Partial Refunds: We do not offer partial refunds for unused portions of billing periods`)
    },
    {
      icon: <CheckCircle className="h-5 w-5 text-primary" />,
      title: AutoTranslate("6. Acceptable Use Policy"),
      content: AutoTranslate(`You agree to use our service responsibly and legally:

• Lawful Use: Use the service only for lawful purposes and in accordance with these terms
• Accurate Information: Provide truthful and accurate information in your resumes
• No Misrepresentation: Do not use false, misleading, or fraudulent information
• Personal Use: The service is intended for personal, non-commercial use
• No Automation: Do not use bots, scrapers, or automated tools to access our service
• Respectful Communication: Maintain respectful communication with our support team
• No System Interference: Do not attempt to interfere with or disrupt our service
• Compliance: Follow all applicable laws and regulations when using our service`)
    },
    {
      icon: <XCircle className="h-5 w-5 text-primary" />,
      title: AutoTranslate("7. Prohibited Activities"),
      content: AutoTranslate(`The following activities are strictly prohibited:

• Illegal Content: Uploading or creating content that violates any laws or regulations
• Harmful Content: Creating resumes with offensive, discriminatory, or harmful content
• Intellectual Property: Violating copyrights, trademarks, or other intellectual property rights
• System Abuse: Attempting to hack, compromise, or gain unauthorized access to our systems
• Spam or Abuse: Sending spam, harassment, or abusive communications
• Commercial Resale: Reselling or redistributing our service without written permission
• Data Mining: Extracting or harvesting data from our service for unauthorized purposes
• Impersonation: Impersonating others or misrepresenting your identity or affiliations`)
    },
    {
      icon: <Shield className="h-5 w-5 text-primary" />,
      title: AutoTranslate("8. Intellectual Property Rights"),
      content: AutoTranslate(`Respect for intellectual property is fundamental to our service:

• Service Ownership: We own all rights to the Resume Builder AI platform, including software, design, and branding
• User Content: You retain ownership of the personal information and content you provide
• License Grant: You grant us a limited license to process your content to provide our service
• Third-Party Content: Respect all third-party intellectual property rights
• Trademark Protection: Our name, logo, and branding are protected trademarks
• Fair Use: Use our service within the bounds of fair use and applicable copyright laws
• DMCA Compliance: We respond promptly to valid DMCA takedown notices`)
    },
    {
      icon: <Zap className="h-5 w-5 text-primary" />,
      title: AutoTranslate("9. Service Availability and Limitations"),
      content: AutoTranslate(`Understanding the scope and limitations of our service:

• Service Availability: We strive for 99.9% uptime but cannot guarantee uninterrupted service
• Maintenance: Scheduled maintenance may temporarily affect service availability
• Technical Limitations: Service performance may vary based on internet connectivity and device capabilities
• Feature Updates: We regularly update features and may discontinue certain functionalities
• Usage Limits: Free accounts have usage limitations; Pro accounts have expanded limits
• Third-Party Dependencies: Service functionality depends on third-party providers like OpenAI and Paystack
• Geographic Restrictions: Service may not be available in all geographic regions`)
    },
    {
      icon: <Shield className="h-5 w-5 text-primary" />,
      title: AutoTranslate("10. Privacy and Data Protection"),
      content: AutoTranslate(`Your privacy and data security are our top priorities:

• Privacy Policy: Our detailed Privacy Policy governs how we handle your personal information
• Data Security: We implement industry-standard security measures to protect your data
• Data Processing: We process your data only as necessary to provide our service
• Third-Party Sharing: We do not sell or share your personal data with third parties for marketing
• User Control: You maintain control over your data and can request deletion at any time
• Compliance: We comply with applicable data protection laws including GDPR and CCPA
• Breach Notification: We will promptly notify users of any data breaches affecting their information`)
    },
    {
      icon: <AlertTriangle className="h-5 w-5 text-primary" />,
      title: AutoTranslate("11. Disclaimers and Limitations of Liability"),
      content: AutoTranslate(`Important legal disclaimers regarding our service:

• Service Provision: Our service is provided "as is" without warranties of any kind
• Resume Success: We cannot guarantee that resumes created will result in employment success
• AI Accuracy: While our AI strives for accuracy, users should review all generated content
• Third-Party Services: We are not responsible for the performance of integrated third-party services
• Limitation of Liability: Our liability is limited to the amount paid for the service in the past 12 months
• Consequential Damages: We are not liable for indirect, incidental, or consequential damages
• Force Majeure: We are not liable for service interruptions due to circumstances beyond our control`)
    },
    {
      icon: <XCircle className="h-5 w-5 text-primary" />,
      title: AutoTranslate("12. Account Termination"),
      content: AutoTranslate(`Conditions under which accounts may be terminated:

• User Termination: You may terminate your account at any time through your account settings
• Service Termination: We may terminate accounts that violate these terms of service
• Immediate Termination: Serious violations may result in immediate account termination
• Data Retention: Account data is retained according to our Privacy Policy and legal requirements
• Refund Eligibility: Terminated accounts may be eligible for refunds according to our refund policy
• Service Migration: We will provide reasonable notice for service discontinuation
• Survival of Terms: Certain terms survive account termination, including intellectual property and liability clauses`)
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-main">
      <SEO
        title="Terms of Service — FIND Resume Builder"
        description="Review the FIND Resume Builder terms of service, user responsibilities, subscription terms, payment policies, and acceptable-use guidelines."
        path="/terms"
      />
      <div
        className="fixed inset-0 opacity-30 pointer-events-none dark:opacity-10"
        style={{
          backgroundImage: `var(--grid-pattern)`,
        }}
      />

      {/* Fixed Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleBackToLanding}
                className="flex items-center text-foreground hover:text-primary"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                <span className="hidden md:inline text-sm md:text-base">{AutoTranslate("Back")}</span>
              </Button>
              <div className="flex items-center space-x-2">
                <FileText className="h-5 w-5 md:h-6 md:w-6 text-primary" />
                <h1 className="text-base md:text-2xl font-bold text-foreground text-center md:text-left">{AutoTranslate("Terms of Service")}</h1>
              </div>
            </div>
            <div className="hidden md:block">
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>

      <div className="relative z-10 mx-auto px-0 pt-32">
        <div className="space-y-8 mb-8">
          {/* Header */}
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              {AutoTranslate(`These terms govern your use of Resume Builder AI and define our mutual rights and responsibilities.`)}
            </p>
            <p className="text-sm text-muted-foreground">
              {AutoTranslate(`Last updated:`)} {lastUpdated}
            </p>
          </div>

          {/* Introduction */}
          <Card className="max-w-4xl justify-center lg:mx-auto mx-4 bg-card/80 backdrop-blur-sm border-card-border">
            <CardContent className="p-6">
              <p className="text-muted-foreground leading-relaxed">
                {AutoTranslate(`Welcome to Resume Builder AI. These Terms of Service ("Terms") govern your use of our AI-powered resume building platform
                operated by Resume Builder AI. By accessing or using our service, you agree to be bound by these Terms.
                If you disagree with any part of these terms, then you may not access the service.`)}
              </p>
            </CardContent>
          </Card>

          {/* Terms Sections */}
          {sections.map((section, index) => (
            <Card key={index} className="max-w-4xl justify-center lg:mx-auto mx-4 bg-card/80 backdrop-blur-sm border-card-border">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  {section.icon}
                  {section.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="prose prose-sm max-w-none text-muted-foreground">
                  {section.content.split('\n').map((paragraph, pIndex) => {
                    if (paragraph.trim().startsWith('•')) {
                      return (
                        <div key={pIndex} className="flex items-start gap-2 mb-2">
                          <span className="text-primary mt-1.5">•</span>
                          <span>{paragraph.trim().substring(1).trim()}</span>
                        </div>
                      );
                    } else if (paragraph.trim()) {
                      return (
                        <p key={pIndex} className="mb-3 leading-relaxed">
                          {paragraph.trim()}
                        </p>
                      );
                    }
                    return null;
                  })}
                </div>
              </CardContent>
            </Card>
          ))}

          {/* Contact Information */}
          <Card className="max-w-4xl justify-center lg:mx-auto mx-4 bg-card/80 backdrop-blur-sm border-card-border">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Mail className="h-5 w-5 text-primary" />
                {AutoTranslate(`13. Contact Information`)}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-3 text-muted-foreground">
                <p className="leading-relaxed">
                  {AutoTranslate(`If you have any questions about these Terms of Service, need clarification on any provisions,
                  or wish to report violations, please contact us:`)}
                </p>
                <div className="bg-muted/50 p-4 rounded-lg">
                  <p className="font-medium text-foreground mb-2">{AutoTranslate(`Legal Department`)}</p>
                  <p className="flex items-center gap-2">
                    <Mail className="h-4 w-4 text-primary" />
                    <a href="mailto:info@wefindservices.org" className="text-primary underline">
                      info@wefindservices.org
                    </a>
                  </p>
                  <p className="text-sm mt-2">
                    {AutoTranslate(`We will respond to legal inquiries within 48 hours during business days.`)}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Governing Law */}
          <Card className="max-w-4xl justify-center lg:mx-auto mx-4 bg-card/80 backdrop-blur-sm border-card-border">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Scale className="h-5 w-5 text-primary" />
                {AutoTranslate(`14. Governing Law and Dispute Resolution`)}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-3 text-muted-foreground">
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <span className="text-primary font-bold">1.</span>
                    <span> {AutoTranslate(`Governing Law: These Terms shall be governed by and construed in accordance with applicable international laws`)}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-primary font-bold">2.</span>
                    <span>{AutoTranslate(`Dispute Resolution: We encourage resolving disputes through direct communication first`)}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-primary font-bold">3.</span>
                    <span>{AutoTranslate(`Arbitration: Unresolved disputes may be subject to binding arbitration`)}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-primary font-bold">4.</span>
                    <span>{AutoTranslate(`Class Action Waiver: You agree to resolve disputes individually, not as part of class actions`)}</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Updates Notice */}
          <Card className="max-w-4xl justify-center lg:mx-auto mx-4 bg-card/80 backdrop-blur-sm border-card-border">
            <CardContent className="p-4">
              <div className="flex items-start gap-2">
                <AlertTriangle className="h-5 w-5 bg-card/80 mt-0.5" />
                <div className="text-sm">
                  <p className="font-medium text-base mb-1">{AutoTranslate("Terms Updates")}</p>
                  <p className="text-muted-foreground">
                    {AutoTranslate(`We may update these Terms of Service from time to time. We will notify you of any material changes
                    by email and by posting the new terms on this page with an updated revision date. Your continued use
                    of the service after such modifications constitutes acceptance of the updated terms.`)}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <Footer />
      </div>
    </div>
  );
}
